import React from 'react'

const PartnersPage = () =>
  <div className="page">
    Partners
  </div>

export default PartnersPage
